/**
 * vue 에서 최초로 호출하는 레이어
 * vue component (push handler) >> push methods >> push service >> vuex
 */
import { orderStatus } from '@/constants';
import { getGlobalStore } from '@/lib/global-store';
import DelayOrder from '@/lib/map-control/share-delay-second/DelayOrder';
import shareOrderShareWorkerBuffer from '@/lib/map-control/shareOrderShareWorkerBuffer';
import { orderPushMethods } from '@/lib/list-control/orderPushMethods';
import Order from '@/entity/Order';
import { listControlActionType } from '@/vuex-store/list-control/actions';
import { socketPayloadType } from '@/constants/socketPayloadType';
const SHARE_ORDER = true;
const { state, dispatch, getters, } = getGlobalStore();
/**
 * 페이로드 구분 이벤트
 */
const payloadEventMethods = {
    payloadEventPayment({ orderId, cardName, cardApproveNumber }) {
        // TODO vuex Complete
        dispatch(listControlActionType.updateOrderCardName, {
            orderId,
            cardName,
        });
        // TODO vuex Complete
        dispatch(listControlActionType.updateOrderCardApproveNumber, {
            orderId,
            cardApproveNumber,
        });
    },
    payloadEventPaymentCancel({ orderId }) {
        // TODO vuex Complete
        dispatch(listControlActionType.deleteOrderCardName, orderId);
        // TODO vuex Complete
        dispatch(listControlActionType.deleteOrderCardApproveNumber, orderId);
    },
};
export const orderPushHandlerList = {
    ...payloadEventMethods,
    /**
     * 타허브 배차건 여부 채크
     * 배차된 타허브 주문은 노출 되면 안됨 (현 허브의 관심사가 아님)
     * @param {*} pushData
     * @returns
     */
    isNotAcceptedAndAllocatedOtherHub(pushData) {
        const { statusCode } = pushData;
        // TODO vuex Complete
        // 모니터링 유저 구분 (허브, 총판)
        // bk const targetId = this.getterIsSubscribeHub ? 'allocatedHubId' : 'allocatedDistributorId';
        const getterIsSubscribeHub = getters['hubSelector/getterIsSubscribeHub'];
        const targetId = getterIsSubscribeHub
            ? 'allocatedHubId'
            : 'allocatedDistributorId';
        const selectedSubscribeHubId = state.hubSelector.subscribeHubInfo[0].id;
        const likeAccept = [
            orderStatus.ACCEPTED.code,
            orderStatus.RE_ACCEPT.code,
            orderStatus.ALLOCATE_CANCEL.code,
        ];
        return (!likeAccept.find((type) => type === statusCode)
            && !!pushData.allocatedWorkerCode
            && pushData[targetId] !== selectedSubscribeHubId);
    },
    /**
     * 접수건 display N 은 노출 x => shareDisplayYn === n은 노출 되면 안됨
     *
     */
    isAcceptedAndDisplayN(pushData) {
        const { statusCode, agencyShareInfo = {}, } = pushData;
        // 접수가 아니어도 아래 상태는 접수가 되는 상태이다.
        const likeAccept = [
            orderStatus.ACCEPTED.code,
            orderStatus.RE_ACCEPT.code,
            orderStatus.WAIT_END.code,
            orderStatus.RESERVE_END.code,
        ];
        return (likeAccept.includes(statusCode)
            && agencyShareInfo.shareDisplayYn === 'N');
    },
    /**
     * 일반 주문 (공유가 아닌 건)
     */
    actionNormalOrder(pushData) {
        const { statusCode, } = pushData;
        orderPushMethods[statusCode](pushData);
    },
    /**
     * 공유건 관련 로직 별도 관리
     * https://barogo.slack.com/archives/C01A1R67RFA/p1645779182400749
     */
    async actionShareOrder(pushData) {
        const { statusCode, orderId, } = pushData;
        // TODO vuex Complete
        const prevOrder = state.mapControl.orderList[orderId];
        // TODO 같은 스코프 채크
        const isNotAcceptedAndAllocatedOtherHub = this.isNotAcceptedAndAllocatedOtherHub(pushData);
        // TODO 같은 스코프 채크
        // displayYn 이 n인 접수건은 제거
        if (this.isAcceptedAndDisplayN(pushData)) {
            // TODO
            this.shareDelaySecondController.delete(orderId);
            orderPushMethods[orderStatus.CANCELED.code](pushData);
            return;
        }
        // 순서이상건 조회 및 제거
        if (statusCode === orderStatus.ACCEPTED.code
            && shareOrderShareWorkerBuffer.has(orderId)) {
            shareOrderShareWorkerBuffer.delete(orderId);
            return;
        }
        // 순서이상건 등록
        // 공유주문공유배차건. 기존 데이터 없이 배차된 경우
        if (isNotAcceptedAndAllocatedOtherHub
            && !prevOrder) {
            shareOrderShareWorkerBuffer.add(orderId);
        }
        // 다른 허브 라이더가 배차한 건 제거
        if (isNotAcceptedAndAllocatedOtherHub) {
            // TODO 같은 스코프 함수 사용
            this.shareDelaySecondController.delete(orderId);
            orderPushMethods[orderStatus.CANCELED.code](pushData);
            return;
        }
        // TODO 같은 스코프 함수 사용
        this.shareDelaySecondController.delete(orderId);
        // TODO 같은 스코프 함수 사용
        // 바로 처리 상태 (지연출력과 연관 x)
        if (this.shareDelaySecondController.isDirectCallStatus(statusCode)) {
            orderPushMethods[statusCode](pushData, SHARE_ORDER);
            // TODO 같은 스코프 함수 사용
            this.shareDelaySecondController.delete(orderId);
            return;
        }
        // TODO 같은 스코프 함수 사용
        // 이미 존재하는 주문은 정보 최신화 (예: order modify)
        const prevDelayOrder = this.shareDelaySecondController.get(orderId);
        if (prevDelayOrder) {
            prevDelayOrder.callback = orderPushMethods[statusCode];
            prevDelayOrder.orderData = pushData;
            // TODO 같은 스코프 함수 사용
            this.shareDelaySecondController.update(orderId, prevDelayOrder);
            return;
        }
        // 신규 추가
        const delayOrder = new DelayOrder();
        delayOrder.callback = orderPushMethods[statusCode];
        delayOrder.orderData = pushData;
        // TODO 같은 스코프 함수 사용
        this.shareDelaySecondController.register(delayOrder);
    },
    /**
     * TODO: 제거 필요
     * 공유건 채크
     * @param pushData
     * @returns
     */
    isShareOrder(pushData) {
        // getter
        const getterIsSubscribeHub = getters['hubSelector/getterIsSubscribeHub'];
        // TODO vuex Complete
        const key = getterIsSubscribeHub ? 'hubId' : 'distributorId';
        // TODO vuex Complete
        const selectedSubscribeHubId = state.hubSelector.subscribeHubInfo[0].id;
        const orderHubId = pushData[key];
        return orderHubId && orderHubId !== selectedSubscribeHubId;
    },
    /**
     * 푸시 이벤트 주문
     */
    handlePushOrder(_pushData) {
        const pushData = Order.convertPushData(_pushData);
        const { payloadType, orderId, statusCode, updatedAt: presentOrderUpdatedAt, } = pushData;
        if (!statusCode) {
            console.log(`[handlePushOrder] statusCode Error: ${statusCode}`, pushData);
            return;
        }
        // TODO
        // 공유주문여부
        const isShareOrder = this.isShareOrder(pushData);
        // TODO vuex Complete
        // 기존 주문과 업데이트 시간 비교
        const prevOrder = state.mapControl.orderList[orderId];
        const prevOrderUpdatedAt = prevOrder ? prevOrder.updatedAt : 0;
        const prevStatusCode = prevOrder ? prevOrder.statusCode : '';
        const likeAccept = [
            orderStatus.ACCEPTED.code,
            orderStatus.RE_ACCEPT.code,
            orderStatus.WAIT_END.code,
            orderStatus.RESERVE_END.code,
        ];
        // 배차 푸시 보다 접수 푸시가 늦게온 경우 접수 무시
        if (likeAccept.includes(statusCode)
            && prevStatusCode === orderStatus.ALLOCATED.code
            && presentOrderUpdatedAt <= prevOrderUpdatedAt) {
            // TODO 나중에 log 서버로 이관
            // this.slackWebHook.sendLog({
            //   message: i18n.t('[handlePushOrder] 기존 데이터가 더 최신 데이터 입니다. 작업 x',
            //   pushData,
            // });
            return;
        }
        // TODO: 리팩토링 필요
        // 페이로드 파싱
        if (payloadType === socketPayloadType.PAYMENT) {
            // TODO
            this.payloadEventPayment(pushData);
            return;
        }
        if (payloadType === socketPayloadType.PAYMENT_CANCEL) {
            // TODO
            this.payloadEventPaymentCancel(pushData);
            return;
        }
        console.log('🍔[handlePushOrder]'
            + ` OrderId: ${orderId},`
            + ` IsShareOrder: ${isShareOrder ? 'O' : 'X'},`
            + ` statusCode: ${statusCode}`);
        if (isShareOrder) {
            // TODO 같은 스코프 메서드
            this.actionShareOrder(pushData);
        }
        else {
            // TODO 같은 스코프 메서드
            this.actionNormalOrder(pushData);
        }
    },
};
export const useHandlePushOrder = () => ({
    ...orderPushHandlerList,
});
export default {
    orderPushHandlerList,
};
